import React from "react";

import { StyledCloseButton } from "./styles";

export type Props = {
  onClose: () => void;
};

export const CloseButton: React.FunctionComponent<Props> = ({ onClose }) => (
  <StyledCloseButton onClick={onClose} />
);

CloseButton.displayName = "CloseButton";
